import { useState } from "react";
import { Building2, KeyRound, Package, ToggleLeft, Truck } from "lucide-react";
import { PageHeader } from "../components/shell/PageHeader";
import { IdentitySettingsPanel } from "../components/settings/IdentitySettingsPanel";
import { SecuritySettingsPanel } from "../components/settings/SecuritySettingsPanel";
import { FeaturesSettingsPanel } from "../components/settings/FeaturesSettingsPanel";
import { OeloxDeliveryFeesPanel } from "../components/settings/OeloxDeliveryFeesPanel";
import { PlansSettingsPanel } from "../components/settings/PlansSettingsPanel";

type TabKey = "identity" | "security" | "features" | "delivery" | "plans";

const TABS: Array<{ key: TabKey; label: string; hint: string; icon: typeof Building2 }> = [
  { key: "identity", label: "Identity", hint: "Brand, support, legal & defaults", icon: Building2 },
  { key: "security", label: "Security", hint: "Password & sessions", icon: KeyRound },
  { key: "features", label: "Features", hint: "Console gates & alert policy", icon: ToggleLeft },
  { key: "delivery", label: "Delivery", hint: "OELOX global driver pricing", icon: Truck },
  { key: "plans", label: "Plans Settings", hint: "Per-trip billing configs", icon: Package },
];

export default function SettingsPage() {
  const [tab, setTab] = useState<TabKey>("identity");

  return (
    <div className="menu-page">
      <PageHeader
        eyebrow="Platform"
        title="Settings"
        subtitle="Identity, security, billing and delivery — every option here is wired to live behavior."
      />

      <div className="sa-settings-layout">
        <nav className="sa-settings-rail" aria-label="Settings sections">
          {TABS.map(({ key, label, hint, icon: Icon }) => (
            <button
              key={key}
              type="button"
              className={`sa-settings-rail__item ${tab === key ? "sa-settings-rail__item--active" : ""}`}
              onClick={() => setTab(key)}
              aria-current={tab === key ? "page" : undefined}
            >
              <span className="sa-settings-rail__icon" aria-hidden>
                <Icon className="h-4 w-4" />
              </span>
              <span className="min-w-0">
                <span className="sa-settings-rail__label">{label}</span>
                <span className="sa-settings-rail__hint">{hint}</span>
              </span>
            </button>
          ))}
        </nav>

        <div className="sa-settings-content">
          {tab === "identity" ? <IdentitySettingsPanel /> : null}
          {tab === "security" ? <SecuritySettingsPanel /> : null}
          {tab === "features" ? <FeaturesSettingsPanel /> : null}
          {tab === "delivery" ? <OeloxDeliveryFeesPanel /> : null}
          {tab === "plans" ? <PlansSettingsPanel /> : null}
        </div>
      </div>
    </div>
  );
}
